function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.8 72.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.32,1.15C11.02,6.44,6.01,25.36,5.92,40.36c-.04,6.36-.49,8.34-3,13-3.64,6.76-3.88,11.84-.71,14.64,6.67,5.88,15.53,5.69,21.1-.47,1.52-1.67,1.74-3.07,1.27-7.85-.32-3.2-1.12-11.22-1.78-17.82-.67-6.6-1.25-18.08-1.3-25.5s-.19-14.01-.31-14.64c-.39-2.01-3.11-2.33-4.87-.57",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.44,38.07c.42,1.77.5,4.24.18,5.5-.52,2.05-1.17,2.29-6.37,2.29h-5.79l.28-8c.4-11.48,1.9-19.6,4.92-26.75C18.24.3,18.4.51,19.07,18.45c.34,9.03.95,17.86,1.37,19.62",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.65,47.97c1.65.44,2.69,2.19,4.24,7.11,1.94,6.19,1.96,6.67.35,9.38-1.73,2.93-6.68,5.89-9.84,5.89-.97,0-3.71-1.14-6.1-2.54-3.28-1.92-4.34-3.15-4.34-5.04,0-2.86,5.55-14.06,7.32-14.78,1.7-.69,5.83-.71,8.37-.03",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/24.2c61e0a45882f78d4a6972e997dbf11f.svg";
export { ForwardRef as ReactComponent };